module.exports = __webpack_public_path__ + "tag.a4099bae838f13ad9c90f41ddf03b0a4.svg";